// extracted by mini-css-extract-plugin
export default {"wrapper":"input_wrapper__4KLBe","error":"input_error__cAeyT"};